/**
 * SKU utility functions for device SKU tracking
 */

// Get display label for SKU
export const getSKUDisplayLabel = (
  configurationName: string | null | undefined
): string => {
  // Empty/null = no SKU assigned
  if (!configurationName) return "";

  if (configurationName === "000-000") return "Legacy";

  if (configurationName === "LEGACY") return "Legacy";

  // Return the configuration name as-is (stored from DynamoDB)
  return configurationName;
};

// Check if device is explicitly marked as Legacy
export const isLegacySKU = (
  configurationName: string | null | undefined
): boolean => {
  return configurationName === "LEGACY" || configurationName === "000-000";
};

// Check if SKU is explicitly set (not null/undefined/empty)
export const isSKUAssigned = (
  configurationName: string | null | undefined
): boolean => {
  return !!configurationName && configurationName.trim() !== "";
};
